/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconViewportNarrow = createReactComponent("viewport-narrow", "IconViewportNarrow", [
  ["path", { d: "M3 12h7l-3 -3m0 6l3 -3", key: "svg-0" }],
  ["path", { d: "M21 12h-7l3 -3m0 6l-3 -3", key: "svg-1" }],
  ["path", { d: "M9 6v-3h6v3", key: "svg-2" }],
  ["path", { d: "M9 18v3h6v-3", key: "svg-3" }]
]);

export { IconViewportNarrow as default };
//# sourceMappingURL=IconViewportNarrow.js.map
